// src/Dashboard/pages/user/Produits/components/ProductsGrid.jsx

import React from "react";

import ProductCard from "./ProductCard";
import SkeletonProductCard from "./SkeletonProductCard";
import EmptyState from "./EmptyState";

export default function ProductsGrid({
  products = [],
  loading,
  error,
  onOpenProduct,
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <SkeletonProductCard key={index} />
        ))}
      </div>
    );
  }

  if (error) {
    return <EmptyState title="Chargement impossible" description={error} />;
  }

  if (!products.length) {
    return (
      <EmptyState
        title="Aucune application trouvée"
        description="Essayez de modifier la recherche ou le tri."
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onOpen={() => onOpenProduct(product)}
        />
      ))}
    </div>
  );
}
